module.exports = __webpack_public_path__ + "img/shadow-01.12dc5a10.png";